module.exports = __webpack_public_path__ + "img/service-flow-planner-1.a477491f.png";